import { Link } from "react-router-dom";
import { CalendarClock, Cpu } from "lucide-react";
import { BackButton, Breadcrumbs, ExternalLink, useEscape } from "../lib/nav";

const EQUIPMENT = ["Pioneer CDJ-3000 x2", "Allen & Heath Xone:96", "Technics SL-1210MK7", "Genelec Monitors", "4K Broadcast Cameras"];

export default function Slots() {
  return (
    <div className="mx-auto max-w-[1600px] px-4 sm:px-6 py-8">
      <div className="flex items-center gap-4 flex-wrap mb-4"><BackButton fallback="/" /><Breadcrumbs items={[{ label: "Live", to: "/" }, { label: "Slots" }]} /></div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tight">Studio Slots</h1>
      <p className="mono-label text-[#71717A] mt-2">BOOK THE RAV3.LABS BROADCAST BOOTH</p>

      <div className="grid lg:grid-cols-[1fr_360px] gap-6 mt-8">
        <div data-testid="slot-booking-calendar" className="card-copper rounded-xl p-6">
          <div className="flex items-center gap-2 mb-4"><CalendarClock className="text-[#E8552A]" size={18} /><span className="font-display font-bold uppercase">Availability</span></div>
          <p className="text-sm text-[#A1A1AA]">Slot booking is handled in the DJ Portal. Register or sign in as a DJ to request a studio recording session — pick your date, time, duration, recording type and genre. An admin confirms your slot.</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-6">
            {["Mon–Fri · 6PM", "Sat · 2PM", "Sat · 8PM", "Sun · 4PM", "Sun · 10PM", "By request"].map((s) => (
              <div key={s} className="border border-[#27272A] rounded-lg p-3 text-center mono-label text-[#A1A1AA] hover:border-[#E8552A]/50">{s}</div>
            ))}
          </div>
          <Link to="/dj" data-testid="go-to-dj-portal" className="inline-block copper-btn rounded-full px-6 py-3 mono-label mt-6">OPEN DJ PORTAL →</Link>
        </div>

        <aside className="card-copper rounded-xl p-6 h-fit">
          <div className="flex items-center gap-2 mb-4"><Cpu className="text-[#E8552A]" size={18} /><span className="font-display font-bold uppercase">Studio Rig</span></div>
          <ul className="space-y-3">
            {EQUIPMENT.map((e) => (<li key={e} className="flex items-center gap-2 text-sm text-[#D4D4D8]"><span className="w-1.5 h-1.5 rounded-full bg-[#E8552A]" />{e}</li>))}
          </ul>
        </aside>
      </div>
    </div>
  );
}
